<template>
  <div class="companyunits">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Company Units</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Company Units</li>
                </ul>
              </div>
              <div class="col-md-3 float-right ml-auto">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Status
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item" @click="getCompanyUnits">All</a>
                  <a class="dropdown-item" @click="getNewCompanyUnits">New</a>
                  <a class="dropdown-item" @click="getCompanyApprovedUnits"
                    >Approved</a
                  >
                  <a class="dropdown-item" @click="getCompanyRejectedUnits"
                    >Rejected</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="companyunits"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setLeaveStatus(item)"
                          v-if="item.status == 0"
                          ><i class="fa fa-pencil m-r-5"></i> Approve or
                          Reject</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Leave Approve</h3>
                <p>Are you sure want to approve for this leave?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeLeaveStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required } from "vuelidate/lib/validators";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
  },
  data() {
    return {
      headers: [
        {
          text: "Company Unit Name",
          align: "start",
          value: "name",
        },
        {
          text: "Status",
          align: "start",
          value: "stat",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false },
      ],
      name: "",
      companyunits: [],
      companyunit: {},
      submitted: false,
      loading: false,
      error: "",
      dialogStatus: false,
      currentUser: authenticationService.currentUserValue,
      fullName: "",
    };
  },

  watch: {
    dialogStatus(val) {
      val || this.closeStatus();
    },
  },

  methods: {
    setLeaveStatus(item) {
      this.companyunit = item;
      this.dialogStatus = true;

      this.fullName =
        this.currentUser.employee.firstName +
        " " +
        this.currentUser.employee.lastName;
      console.log(this.fullName, "hello");
    },

    changeLeaveStatus(status) {
      this.submitted = true;
      this.companyunit.status = status;
      const id = this.companyunit.id;
      this.companyunit.approvedByGMD = this.fullName;
      this.companyunit.approvedDateByGMD = new Date();
      console.log(this.companyunit.status);
      this.loading = true;
      organizationService.updateCompanyUnitsByGMD(id, this.companyunit).then(
        (id) => {
          var unit = JSON.parse(localStorage.getItem("companyUnit"));
          organizationService.getCompanyUnits(unit.id).then((o) => {
            this.companyunits = o.filter(
              (c) => c.approvedByGMD == null && c.status == 0
            );
            this.closeStatus();
          });

          console.log("companyunit approved");
        },
        (error) => {
          this.error = error;
          this.closeStatus();
          this.loading = false;
        }
      );
    },

    getNewCompanyUnits() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getCompanyUnits(unit.id).then(
        (model) => {
          this.companyunits = model.filter(
            (c) => c.approvedByGMD == null && c.status == 0
          );
          // console.log("leaves:", model[0]);
        },
        (error) => {
          error = error;
        }
      );
    },

    setDepartment(item) {
      this.companyunit = item;
    },

    closeStatus() {
      this.dialogStatus = false;
    },

    getCompanyUnits() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getCompanyUnits(unit.id).then(
        (model) => {
          this.companyunits = model;
          // .filter(
          //   (c) => c.approvedByGMD == null && c.status == 0
          // );
        },
        (error) => {
          error = error;
        }
      );
    },

    getCompanyApprovedUnits() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getCompanyUnits(unit.id).then(
        (model) => {
          this.companyunits = model.filter((c) => c.status == 1);
          // console.log("leaves:", model[0]);
        },
        (error) => {
          error = error;
        }
      );
    },

    getCompanyRejectedUnits() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      organizationService.getCompanyUnits(unit.id).then(
        (model) => {
          this.companyunits = model.filter((c) => c.status == 2);
          // console.log("leaves:", model[0]);
        },
        (error) => {
          error = error;
        }
      );
    },
  },

  mounted() {
    this.getNewCompanyUnits();
  },
  name: "companyunits",
};
</script>


// WEBPACK FOOTER //
// src/components/miscs/companyUnitsApprovedByGMD.vue